import { Settings } from "@/components/ui/settings";
import { Text } from "@/components/ui/text";
import {
    SUPPORTED_LANGUAGES,
    SYSTEM_LANGUAGE,
    useLanguagePreference,
} from "@/i18n";
import * as Linking from "expo-linking";
import { Stack } from "expo-router";
import { Trans, useTranslation } from "react-i18next";
import { Platform, ScrollView } from "react-native";

import { SafeAreaView } from "react-native-safe-area-context";
import { TEST_IDS } from "../../../testIdDefinition";

function LanguageFooter() {
    const { t, i18n } = useTranslation();

    if (Platform.OS === "web") {
        return (
            <Text key={i18n.language} variant="caption" className="px-1">
                {t("settings.display.languageFooterWeb")}
            </Text>
        );
    }

    if (Platform.OS === "android" && Platform.Version < 33) {
        // language change in system settings is not supported on Android < 13 (API 33)
        return null;
    }

    return (
        <Text key={i18n.language} variant="caption" className="px-1">
            <Trans
                i18nKey="settings.display.languageFooter"
                t={t}
                parent={null}
                components={{
                    settingsLink: (
                        <Text
                            variant="caption"
                            className="text-primary underline"
                            accessibilityRole="link"
                            onPress={() => {
                                void Linking.openSettings();
                            }}
                            testID={
                                TEST_IDS[
                                    TEST_IDS
                                        .SETTINGS_DISPLAY_LANGUAGE_OPEN_SETTINGS_LINK
                                ]
                            }
                        />
                    ),
                }}
            />
        </Text>
    );
}

export default function LanguageSwitch() {
    const { t } = useTranslation();

    const { preference, changeLanguage, systemLanguage } =
        useLanguagePreference();

    return (
        <SafeAreaView className="flex-1 bg-background" edges={["bottom"]}>
            <ScrollView
                className="flex-1"
                contentContainerClassName="gap-6 px-4 pb-6 pt-2 web:mx-auto web:w-full web:max-w-lg"
                testID={TEST_IDS[TEST_IDS.LANGUAGE_SCREEN]}
            >
                <Stack.Screen
                    options={{ title: t("settings.display.language") }}
                />
                <Settings
                    title={t("settings.display.language")}
                    footer={
                        <LanguageFooter
                            key={`language-footer-${preference}-${systemLanguage}`}
                        />
                    }
                >
                    <Settings.Item
                        selected={preference === SYSTEM_LANGUAGE}
                        label={t(
                            `settings.display.language-${SYSTEM_LANGUAGE}`,
                        )}
                        onPress={() => changeLanguage(SYSTEM_LANGUAGE)}
                        description={`(${t(`settings.display.language-${systemLanguage}`)})`}
                        testID={
                            TEST_IDS[
                                TEST_IDS
                                    .SETTINGS_DISPLAY_LANGUAGE_OPTION_DEFAULT
                            ]
                        }
                    />

                    {SUPPORTED_LANGUAGES.map((language) => {
                        const selected = preference === language;
                        return (
                            <Settings.Item
                                selected={selected}
                                key={language}
                                label={t(
                                    `settings.display.language-${language}`,
                                )}
                                onPress={() => changeLanguage(language)}
                            ></Settings.Item>
                        );
                    })}
                </Settings>
            </ScrollView>
        </SafeAreaView>
    );
}
